import * as htmlToImage from "../vendor/html-to-image.js";

/**
 * html-to-image (SVG foreignObject) — bundlé par webpack, plus de chargement script global.
 */
export function loadHtmlToImage() {
  if (htmlToImage?.toCanvas) {
    return Promise.resolve(htmlToImage);
  }
  return Promise.reject(new Error("html-to-image indisponible"));
}
